import { HTTP_TOKEN } from "./http";

export const getTagTrack = () => {
  return HTTP_TOKEN.get("tagtrack").then(result => {
    return result.data;
  });
};

export const updateTagTrack = data => {
  return HTTP_TOKEN.post("tagtrack", data).then(result => {
    return result.data;
  });
};

